import { render, staticRenderFns } from "./InsertImage.vue?vue&type=template&id=38137d49&scoped=true&"
import script from "./InsertImage.vue?vue&type=script&lang=js&"
export * from "./InsertImage.vue?vue&type=script&lang=js&"
import style0 from "./InsertImage.vue?vue&type=style&index=0&id=38137d49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38137d49",
  null
  
)

export default component.exports